import { renderDate, renderMoney, dateRangeFilter } from "common/services/util"
import React from 'react';
import DateRangeFilter from 'common/components/DateRangeFilter';

export const mapPaymentMode = {
    0: "Sin pagar",
    1: "Tarjeta",
    2: "Efectivo"
}

export const getColumnsTickets = ({
    reference,
    searchClients,
    selectPaymentMode,
    searchTasks,
    checkedSelected,
    checkAll
}) => {
    const columns = [
        { 
            title: '', 
            field: 'selected', 
            render: props => checkedSelected(props),
            editable: 'never', 
            cellStyle: { width: '30px'},
            filterComponent: () => checkAll()
        },
        {
            title: 'Nº Ticket',
            field: 'numTicket',
            render: rowData => reference(rowData),
            editable: 'never'
        },
        {
            title: 'Cliente',
            field: 'nameClient',
            editComponent: ({ rowData }) => searchClients(rowData)
        },
        {
            title: 'CIF',
            field: 'dniClient',
            editable: 'never'
        },
        {
            title: 'Concepto',
            field: 'concept'
        },
        {
            title: 'Fecha',
            field: 'ticketDate',
            type: 'datetime',
            filterComponent: props => <DateRangeFilter {...props} />,
            customFilterAndSearch: (filter, rowData) => dateRangeFilter(filter, rowData.ticketDate),
            render: rowData => renderDate(rowData ? rowData.ticketDate : "", true)
        },
        {
            title: 'Total',
            field: 'totalPrice',
            render: rowData => renderMoney(rowData ? rowData.totalPrice : ""),
            align: 'right',
            editable: 'never'
        },
        {
            title: 'Base',
            field: 'basePrice',
            render: rowData => renderMoney(rowData ? rowData.basePrice : ""),
            align: 'right',
            editable: 'never'
        },
        {
            title: 'IVA',
            field: 'ivaPercent',
            type: 'numeric',
            render: rowData => (rowData.ivaPercent || 21) + " %",
            initialEditValue: 21
        },
        {
            title: 'Tipo pago',
            field: 'paymentMode',
            lookup: mapPaymentMode,
            editable: "never",
            initialEditValue: 0
        },
        {
            title: 'Tarea asociada',
            field: 'taskReference',
            editComponent: ({ rowData }) => searchTasks(rowData)
        },
        {
            title: 'Factura asociada',
            field: 'numCanjeInvoice',
            editable: 'never',
            filtering: false,
        }
    ]

    return columns
}